import React, { useEffect } from 'react';
import './ConnectPage.css';

const ConnectPage = () => {
    useEffect(() => {
        // Animate elements on mount
        const animateElements = () => {
            const elements = document.querySelectorAll('.animate-line');
            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('visible');
                }, 300 + (index * 200));
            });
        };

        animateElements();
    }, []);

    return (
        <div className="connect-page">
            <div className="connect-content">
                {/* Main Connect Section */}
                <section className="connect-section">
                    <h1 className="animate-line">Let's collaborate</h1>
                    
                    <div className="connect-text">
                        <p className="animate-line">
                            I partner with individuals, brands, and agencies to craft 3D visuals, immersive experiences, and creative technology projects. If you're looking for something more specific, or would like to see my full offline portfolio, just drop me a <a href="mailto:jacob@ordos.co.uk" className="connect-link">message</a> — I'd love to hear from you.
                        </p>
                    </div>
                </section>

                {/* Contact Links Section */}
                <section className="contact-links-section">
                    <h2 className="animate-line">Get in touch</h2>
                    <div className="contact-links">
                        <div className="contact-item animate-line">
                            <a href="mailto:jacob@ordos.co.uk" className="contact-link">
                                <span>jacob@ordos.co.uk</span>
                            </a>
                        </div>
                        <div className="contact-item animate-line">
                            <a href="https://www.instagram.com/ordos.studio" target="_blank" rel="noopener noreferrer" className="contact-link">
                                <span>@ordos.studio</span>
                            </a>
                        </div>
                    </div>
                </section>

                {/* Services Section */}
                <section className="services-section">
                    <h2 className="animate-line">What I offer</h2>
                    <div className="services-grid">
                        <div className="service-item animate-line">
                            <h3>3D Production</h3>
                            <p>Cinema 4D, Blender, and real-time 3D graphics for commercials, music videos, and digital experiences.</p>
                        </div>
                        <div className="service-item animate-line">
                            <h3>Interactive Installations</h3>
                            <p>Touch Designer, Unity, and custom software for immersive installations and interactive art.</p>
                        </div>
                        <div className="service-item animate-line">
                            <h3>Creative Technology</h3>
                            <p>End-to-end project support from concept development through to final execution.</p>
                        </div>
                        <div className="service-item animate-line">
                            <h3>Real-time Experiences</h3>
                            <p>Live visuals, VJ sets, and real-time graphics for events and performances.</p>
                        </div>
                        <div className="service-item animate-line">
                            <h3>Bespoke Tool Building</h3>
                            <p>Custom automation tools and scripts to streamline workflows and automate repetitive tasks.</p>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="connect-footer">
                    <p className="animate-line">© <span id="year"></span> Jacob Faulkner All rights reserved.</p>
                    <p className="animate-line">No cookies, no tracking, no bullshit.</p>
                </footer>
            </div>
        </div>
    );
};

export default ConnectPage; 